import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { ManagePremiumStoreInfoPayload } from '../premiumStores/premiumStores.types';
import { AddManageStoreInfoPayload, BasicStores, StoreDeletePayload, ToggleStatusPayload } from './basicStores.types';

const toggleBasicStoresStatus = (client: AxiosInstance) => async (payload: ToggleStatusPayload) => {
  return (
    await client.post<{ message: string; data: BasicStores }>(API_ROUTES.BLOCK_UNBLOCK_BASIC_STORE_INFO, {
      clubId: payload.clubId,
      status: payload.status,
    })
  ).data;
};

const createBasicStoreInfo = (client: AxiosInstance) => async (payload: AddManageStoreInfoPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.ADD_BASIC_STORE, payload)).data;
};

const updateBasicStoreInfo = (client: AxiosInstance) => async (payload: AddManageStoreInfoPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_BASIC_STORE_INFO, payload)).data;
};

const deleteBasicStoreInfo = (client: AxiosInstance) => async (payload?: StoreDeletePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.DELETE_BASIC_STORE_INFO, payload)).data;
};

const switchToPremiumStore = (client: AxiosInstance) => async (payload: ManagePremiumStoreInfoPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.SWITCH_STORE_INFO, payload)).data;
};

export const basicStoresMutations = {
  toggleBasicStoresStatus,
  createBasicStoreInfo,
  updateBasicStoreInfo,
  deleteBasicStoreInfo,
  switchToPremiumStore,
};
